import axios from "axios";
import { captureServices } from "../communication";
import { t } from '@mp/locale';
var captureServicesRoot = "/api/mp/capturesvcs";
var orderRoot = "".concat(captureServicesRoot, "/preorder");
var publicRegionRoot = "".concat(captureServicesRoot, "/public/region");
var availability = "".concat(orderRoot, "/availability");
axios.defaults.withCredentials = true;
var orderId = "";
export function setOrderId(id) {
    orderId = id;
}
export function setApiRoot(value) {
    axios.defaults.baseURL = value;
}
export var propertyTypes = {
    RESIDENTIAL: t("CAPTURE_SERVICES.PROPERTY_TYPES.RESIDENTIAL"),
    COMMERCIAL: t("CAPTURE_SERVICES.PROPERTY_TYPES.COMMERCIAL"),
};
export var unitSizeLabels = {
    SQUARE_METER: t("CAPTURE_SERVICES.SIZE_UNIT_SHORT_LABELS.SQUARE_METER"),
    SQUARE_FT: t("CAPTURE_SERVICES.SIZE_UNIT_SHORT_LABELS.SQUARE_FT"),
};
export var trackingEvents = {
    ADDRESS_AVAILABLE: "capture_services_available",
    BACK: "capture_services_back",
    ADDRESS_COMPLETED: "capture_services_finder_address_completed",
    ADDRESS_NO_SUGGESTIONS: "capture_services_finder_address_no_suggestion",
    ADDRESS_STARTED: "capture_services_finder_address_started",
    ADDRESS_UNAVAILABLE_ERROR: "capture_services_address_error_unavailable",
    ADDRESS_UNAVAILABLE: "capture_services_unavailable",
    APPOINTMENT_SELECTED: "capture_services_appointment_selected",
    CANCEL_POLICY_CLICKED: "capture_services_cancel_policy",
    CAPTURE_SERVICES_ORDER_PROGRESS: "capture_services_order_progress",
    CAPTURE_SERVICES_UNAVAILABLE: "capture_services_unavailable",
    CHECK_ANOTHER_ADDRESS: "check_another_address",
    END_CAPTURE_SERVICES_ORDER: "end_capture_services_order",
    PROPERTY_DETAILS_CAPTURE_LOCATION_ENTERED: "capture_services_property_capture_location_entered",
    PROPERTY_DETAILS_PROPERTY_SIZE_UNIT_ENTERED: "capture_services_property_size_unit_entered",
    PROPERTY_DETAILS_TOTAL_PROPERTY_SIZE_ENTERED: "capture_services_total_property_size_entered",
    PROPERTY_DETAILS_TYPE_ENTERED: "capture_services_property_type_entered",
    SIZE_TOO_LARGE: "capture_services_size_too_large",
    SPECIAL_REQUEST_ENTERED: "capture_services_special_request",
    SUBMITTED_CAPTURE_SERVICES_ORDER: "submitted_capture_services_order",
    TERMS_OF_SERVICE_CLICKED: "capture_services_terms_of_service",
    TYPE_ENTERED: "capture_services_type_entered",
};
export var TRACKING_NAMESPACE = "capture-services-scheduler";
export function checkAddress(data) {
    return axios.post(publicRegionRoot, data);
}
// TODO: update response object
export function initiateOrder(data) {
    if (orderId) {
        return patchOrder(data, "property-details");
    }
    return axios.post(orderRoot, data).then(function (_a) {
        var data = _a.data;
        var id = data.id;
        orderId = id;
        captureServices.broadcast("start", orderId);
        return data;
    });
}
export function patchOrder(data, step) {
    return axios
        .patch("".concat(orderRoot, "/").concat(orderId), data)
        .then(function (_a) {
        var data = _a.data;
        // The estimated price has changed.
        // Tell listening apps to update.
        if (step === "property-details") {
            captureServices.broadcast("change");
        }
        return data;
    });
}
export function submitOrder() {
    return axios.post("".concat(orderRoot, "/").concat(orderId, "/submit")).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
export function getAvailability(start_date) {
    var params = {
        pre_order_id: orderId,
        start_date: start_date,
    };
    return axios.get(availability, { params: params });
}
export function getOrderPreview() {
    return axios.get("".concat(orderRoot, "/").concat(orderId, "/preview")).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
export function getOrder() {
    return axios.get("".concat(orderRoot, "/").concat(orderId)).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
export function clearOrderId() {
    orderId = "";
}
